import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Login from "@/pages/Login.vue";
import ResetPassword from "@/pages/ResetPassword.vue";
import Register from "@/pages/Register.vue";

// User Viwes
import Items from '@/pages/users/Items.vue'


// Admin pages
import Users from '@/pages/admin/Users.vue'
import Categories from '@/pages/admin/Categories.vue'
import InventoryItems from '@/pages/admin/InventoryItems.vue'
import Quotes from '@/pages/admin/Quotes.vue'


import Dashboard from "@/pages/Dashboard.vue";

const routes = [
  {
    path: "/admin",
    component: DashboardLayout,
    redirect: "/admin/dashboard",
    children: [
      
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "users",
        name: "users",
        component: Users,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "categories",
        name: "categories",
        component: Categories,
        meta: {
          requiresAuth: true,
        }
      },
      
      {
        path: "inventory",
        name: "InventoryItems",
        component: InventoryItems,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: "quotes",
        name: "Quotes",
        component: Quotes,
        meta: {
          requiresAuth: true,
        }
      }
    ]
  },
  {
    path: "/user",
    component: DashboardLayout,
    redirect: "/user/items",
    children: [
      {
        path: "items",
        name: "Items",
        component: Items,
        meta: {
          requiresAuth: true,
        }
      }
    ]
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/",
    name: "login",
    component: Login
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
